export const connectWallet = 'Connect your wallet'
export const collateralAssetNotSelected = 'Collateral asset is not selected'
export const borrowedAssetNotSelected = 'Borrowed asset is not selected'
export const depositAssetNotSelected = 'Deposit asset is not selected'
export const riskNotSelected = 'Target risk is not selected'
export const assetAddressNotDefined = 'Address does not defined for this asset'
export const noTokenId = 'Token id not found'
export const noSigner = 'Signer not found'
export const protocolPaused = `The protocol is temporarily paused. Please try again a bit later and follow the announcements in Discord and Twitter!`
export const csApiError =
  'Error while trying to load credit score API data. Pleasy try again a bit later'
export const nonPrimary = 'Please switch to Primary Address in order to borrow'
